import app from "../../libs/apiClient";
import { handleActions } from "redux-actions";
import { initialize as initializeForm } from 'redux-form';
import swal from "sweetalert2";
import { errorHandler } from '../../common/utility/constants';


const service = app.service("/api/erp_issue");


const SET_LOADING = "SET_LOADING_ERP_ISSUE";

// Actions
const create = (values) => (dispatch, getState) => {
    dispatch(loading(SET_LOADING, true));

    service.create(values).then((response) => {
        swal.fire({
            type: "success",
            title: "Success!",
            text: "Your request has been submitted. For additional questions or follow-up please reach out to infosystems@connectbbc.com"
        }).then(() => {
            dispatch(initializeForm("erp_issue", {}))
        })
    }).catch((e) => {
        dispatch(errorHandler(e));
    }).finally(() => {
        dispatch(loading(SET_LOADING, false));
    });
};

export const actions = {
    create,
}

const loading = (type, loading) => ({ type, loading });

// Reducers
const reducers = {
    [SET_LOADING]: (state, { loading }) => ({ ...state, loading }),
};

export const initialState = {
    loading: false,
};

export default handleActions(reducers, initialState);
